// types.ts

import {ReferenceType, ExchangeType} from "./enums";

export enum TextType {
    SENTENCE = 'SENTENCE',
    PARAGRAPH = 'PARAGRAPH',
    SUMMARY_INFO = 'SUMMARY_INFO',
}

export interface ReferenceCreate {
    reference_type: ReferenceType;
    text_granularity: TextType;
    referenced_text_id: string;
    referenced_doc_id: string;
    similarity_score?: number;
    association_id: string;
    chat_id?: string;
}

export interface ReferenceRead  extends ReferenceCreate {
    id: string;
    explanation?: string;
    exchange_type?: ExchangeType;
    page_start?: number;
    line_start?: number;
    line_end?: number;
    body_start?: number;
    body_end?: number;
}

export interface ReferenceReadWText extends ReferenceRead {
    referenced_text_id: string;
    referenced_text: string;
}

/** Format a reference citation like "p. 47:12–18" */
export function formatCitation(ref: {
    page_start?: number | null;
    line_start?: number | null;
    line_end?: number | null;
}): string {
    if (ref.page_start == null) return '';
    let s = `p. ${ref.page_start}`;
    if (ref.line_start != null) {
        s += `:${ref.line_start}`;
        if (ref.line_end != null && ref.line_end !== ref.line_start) {
            s += `\u2013${ref.line_end}`;
        }
    }
    return s;
}

/** Format a full legal citation like "Nadeau Dep. 47:12–18" */
export function formatLegalCitation(
    deponentOrTitle: string,
    ref: { page_start?: number | null; line_start?: number | null; line_end?: number | null },
): string {
    if (ref.page_start == null) return deponentOrTitle;
    let page = `${ref.page_start}`;
    if (ref.line_start != null) {
        page += `:${ref.line_start}`;
        if (ref.line_end != null && ref.line_end !== ref.line_start) {
            page += `\u2013${ref.line_end}`;
        }
    }
    return `${deponentOrTitle} Dep. ${page}`;
}

export interface ReferenceUpdate {
    text_granularity?: TextType;
    referenced_text_id?: string;
    referenced_doc_id?: string;
    similarity_score?: number;
    chat_id?: string;
}
